import Popper from 'popper.js' ;//Importar Popper

window.Popper = Popper; //Inicializar Popper
